export function useCantPay() {
  const handleGo = () => {
    window.open(import.meta.env.VITE_URL, '_blank')
  }

  return { handleGo }
}
